import { Country } from "@/data/constants/country";
import { Oriented } from "@/data/constants/oriented";
import { Translation } from "@/data/lang";
import { links } from "@/data/links";
import { Lang } from "@/i18n-config";

import {
  NavigationLink,
  getDividendLinks,
  getOverviewLinks,
  getSwingTradingLinks,
  getTWWhaleInterestLinks,
  getTrendLinks,
  getUSWhaleInterestLinks,
  getValueLinks,
} from "./navigation-links";

type NavigationSection = {
  key: Oriented | "overview";
  title: string;
  pageLink: string;
  subLinks: NavigationLink[];
};

export const getNavigationList = ({
  lang,
  t,
  symbol,
  country,
}: {
  lang: Lang;
  t: Translation;
  symbol: string;
  country: Uppercase<Country>;
}): NavigationSection[] => [
  {
    key: "overview",
    title: t.analysis.shared.oriented.overview,
    pageLink: `/${lang}${links.myAnalysisOverview({ symbol })}`,
    subLinks: getOverviewLinks({ t }),
  },
  {
    key: "value",
    title: t.analysis.shared.oriented.value,
    pageLink: `/${lang}${links.myAnalysisValue({ symbol })}`,
    subLinks: getValueLinks({ t }),
  },
  {
    key: "trend",
    title: t.analysis.shared.oriented.trend,
    pageLink: `/${lang}${links.myAnalysisTrend({ symbol })}`,
    subLinks: getTrendLinks({ t }),
  },
  {
    key: "swing",
    title: t.analysis.shared.oriented.swing,
    pageLink: `/${lang}${links.myAnalysisSwingTrading({ symbol })}`,
    subLinks: getSwingTradingLinks({ t }),
  },
  {
    key: "chip",
    title: t.analysis.shared.oriented.chip,
    pageLink: `/${lang}${links.myAnalysisWhaleInterest({ symbol })}`,
    subLinks: getWhaleInterestLinks({ country, t }),
  },
  {
    key: "dividend",
    title: t.analysis.shared.oriented.dividend,
    pageLink: `/${lang}${links.myAnalysisDividend({ symbol })}`,
    subLinks: getDividendLinks({ t }),
  },
];

const getWhaleInterestLinks = ({
  country,
  t,
}: {
  country: Uppercase<Country>;
  t: Translation;
}): NavigationLink[] => {
  switch (country) {
    case "US":
      return getUSWhaleInterestLinks({ t });
    case "TW":
      return getTWWhaleInterestLinks({ t });
    default:
      return [];
  }
};
